/* unplugin-vue-components disabled */import { render } from "./SvgIconMoney.vue?vue&type=template&id=2bf769ba"
import script from "./SvgIconMoney.vue?vue&type=script&lang=js"
export * from "./SvgIconMoney.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__